export default __webpack_public_path__ + "static/media/worktuallogo.91161c55.svg";